export default __webpack_public_path__ + "static/media/cop6.8a6b8f1f.png";